import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { DownloadAppButtonsComponent } from '../../../shared/components/download-app-buttons/download-app-buttons.component';
import { RouterSwitchBtnComponent } from '../../../shared/components/router-switch-btn/router-switch-btn.component';
import { Store } from '@ngxs/store';
import { UpdatedSideGraphic } from '../../../store/onboarding/onboarding.actions';
import { ProgressBarService } from '../../../_services/progress-bar-service/progress-bar.service';

@Component({
  selector: 'app-base-success',
  imports: [NgOptimizedImage, DownloadAppButtonsComponent, RouterSwitchBtnComponent],
  templateUrl: './base-success.component.html',
})
export abstract class BaseSuccessComponent {
  readonly store = inject(Store);
  readonly progressBarService = inject(ProgressBarService);
  protected abstract subTitle: string;

  constructor() {
    this.store.dispatch(new UpdatedSideGraphic('reg8_success.svg'));
    this.progressBarService.setHideProgress(true);
  }
}
